"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale integrations Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WholesaleEventType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.WholesaleEventType = {
    FreightOrdered: 'FREIGHT_ORDERED',
    ShipmentStatusChanged: 'SHIPMENT_STATUS_CHANGED',
    ShipmentSubmitted: 'SHIPMENT_SUBMITTED',
    OrderStatusChanged: 'ORDER_STATUS_CHANGED',
    ProNumberReceived: 'PRO_NUMBER_RECEIVED',
    OutOfStock: 'OUT_OF_STOCK',
    ShipmentTransportationChanged: 'SHIPMENT_TRANSPORTATION_CHANGED',
    ShipmentReadyForFreightOrdering: 'SHIPMENT_READY_FOR_FREIGHT_ORDERING',
    ShipmentReadyForParcelOrdering: 'SHIPMENT_READY_FOR_PARCEL_ORDERING',
    ShipmentTypeChanged: 'SHIPMENT_TYPE_CHANGED',
    ShipmentAttachmentUpdated: 'SHIPMENT_ATTACHMENT_UPDATED'
};
//# sourceMappingURL=wholesale-event-type.js.map